import { Component, ViewEncapsulation } from '@angular/core';
import { CallState } from '@lcs/shared/api';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { getAppStartCallState } from 'src/app/app-start/app-start.selectors';
import { AppState } from 'src/app/app.reducer';
import { LoginDetails } from 'src/app/authentication/models/login-details.model';
import { login, ssoLogin } from 'src/app/authentication/state/authentication.actions';
import {
   getLoginCallState,
   getUsernameQueryParameter,
   selectLoginError,
} from 'src/app/authentication/state/authentication.selector';
import { hasSaml2Authentication } from 'src/app/common-components/utils/sso-helper';
import { userPasswordResetRequest } from '../../user-password-reset-request/state/user-password-reset-request.actions';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-login',
    templateUrl: './login.component.html',
    standalone: false
})
export class LoginComponent {
   appStartCallState: Observable<CallState>;

   loginCallState: Observable<CallState>;

   loginError$: Observable<string | null>;

   username$: Observable<string | null>;

   hasSaml2Authentication$: Observable<boolean | undefined>;

   constructor(private store: Store<AppState>) {
      this.loginCallState = store.pipe(select(getLoginCallState));
      this.appStartCallState = store.pipe(select(getAppStartCallState));
      this.username$ = store.pipe(select(getUsernameQueryParameter));
      this.loginError$ = store.pipe(select(selectLoginError));
      this.hasSaml2Authentication$ = hasSaml2Authentication();
   }

   onLoginClick(loginDetail: LoginDetails): void {
      this.store.dispatch(login(loginDetail));
   }

   onCannotSignInClick(): void {
      this.store.dispatch(userPasswordResetRequest());
   }

   onLoginWithSSO() {
      this.store.dispatch(ssoLogin({ fromDialog: false }));
   }
}
